import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgBd = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#006A4E",
      d: "M12 0c1.429 0 2.799.25 4.07.709V.708l.057.021.045.016v.001C20.725 2.435 23.975 6.806 24 11.94v.12c-.025 5.134-3.275 9.504-7.828 11.193v.002l-.045.015q-.03.01-.057.022v-.002c-1.271.458-2.641.71-4.07.71-1.428 0-2.797-.251-4.067-.709v.002q-.028-.011-.056-.021l-.049-.017v-.002C3.258 21.558 0 17.16 0 12S3.258 2.441 7.828.746l.043-.017.064-.023v.002A12 12 0 0 1 12 0"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F42A41",
      d: "M10 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgBd;